import './TextLesson.scss';
import DOMPurify from 'dompurify';

type TextLessonProps = {
  text: string;
};

export const TextLesson = ({ text }: TextLessonProps) => {
  return (
    <div
      className='text-content lesson-content'
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text, { ADD_ATTR: ['target'] }) }}
    ></div>
  );
};
